import { useMemo } from "react";
import { harmonies } from "../lib/color";
import { PaletteSwatch } from "./PaletteSwatch";

const ORDER = [
  ["complementary", "Complementary"],
  ["split-complementary", "Split Complementary"],
  ["analogous", "Analogous"],
  ["triadic", "Triadic"],
  ["tetradic", "Tetradic / Square"],
  ["double-complementary", "Double Complementary"],
];

export function HarmonyPalettes({ hex, onSelect }) {
  const data = useMemo(() => harmonies(hex), [hex]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <section className="space-y-6">
      <div className="flex items-baseline justify-between border-b border-border pb-2">
        <h2 className="text-sm font-bold uppercase tracking-[0.2em]">
          Harmony Palettes
        </h2>
        <span className="text-[10px] uppercase tracking-[0.2em] text-muted">
          CMYK-optimised
        </span>
      </div>

      <div className="space-y-6">
        {ORDER.map(([key, label]) => (
          <div key={key} className="space-y-2" data-testid={`harmony-group-${key}`}>
            <div className="flex items-baseline justify-between">
              <h3 className="text-xs font-medium uppercase tracking-[0.2em] text-muted">
                {label}
              </h3>
              <span className="font-mono text-[10px] text-muted">
                {data[key].length} swatches
              </span>
            </div>
            <div
              className="grid gap-3 grid-cols-2"
              style={{ gridTemplateColumns: `repeat(${data[key].length}, minmax(0, 1fr))` }}
            >
              {data[key].map((c, i) => (
                <PaletteSwatch
                  key={key + i}
                  hex={c}
                  testId={`palette-swatch-${key}-${i}`}
                  copyTestId={`copy-hex-button-${key}-${i}`}
                  onSelect={() => onSelect(c)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
